import routerPaycools from './router/paycools'
import routerMoneypay from './router/ezpay'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

let router
if (['paycools', 'moneypay','id','mx'].includes(process.env.VUE_APP_PLATFORM)) {
  router = routerPaycools
}

if (process.env.VUE_APP_PLATFORM === 'ezpay') {
  router = routerMoneypay
}

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/forgotPassword', '/register', '/register/services-agreements', '/register/privacy-policy'] // no redirect whitelist
// const whiteRouterNameList = []
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo) {
        next()
      } else {
        try {
          // get user info
          store.dispatch('user/getInfo').then(res => {
            const { auth_codes, country_code } = res
            let authorities = auth_codes || []
            if (res.merchant_model === 2) {
              authorities = ['ROLE_AUTH_AGENT_ADMIN']
            }
            store.dispatch('generateRoutes', { authorities, country_code }).then(accessRoutes => {
              // 根据roles权限生成可访问的路由表
              router.addRoutes(accessRoutes) // 动态添加可访问路由表
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            })
            next()
          })
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    // whiteRouterNameList.includes(to.name)
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
